import { Routes } from '@angular/router';
import { LayoutComponent } from './core/layout/layout.component';
import { canActivateAssistantResource, canActivateAuthRole } from './core/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    canActivate: [canActivateAuthRole],
    children: [
      { path: '', redirectTo: 'modules', pathMatch: 'full' },
      {
        path: 'modules',
        canActivate: [canActivateAuthRole],
        loadComponent: () =>
          import('./features/dashboard/pages/modules-dashboard/modules-dashboard.component').then(
            (m) => m.ModulesDashboardComponent,
          ),
      },
      {
        path: 'users',
        canActivate: [canActivateAuthRole],
        loadComponent: () =>
          import('./features/users/pages/users-dashboard/users-dashboard.component').then(
            (m) => m.UsersDashboardComponent,
          ),
      },
      {
        path: 'handover',
        canActivate: [canActivateAuthRole],
        loadComponent: () =>
          import('./features/handover/pages/handover-dashboard/handover-dashboard.component').then(
            (m) => m.HandoverDashboardComponent,
          ),
      },
      {
        path: 'assistant',
        canActivate: [canActivateAssistantResource],
        loadComponent: () =>
          import('./features/assistant/pages/digital-assistant/digital-assistant.component').then(
            (m) => m.DigitalAssistantComponent,
          ),
      },
      {
        path: 'access-denied',
        loadComponent: () =>
          import('./features/assistant/pages/access-denied/access-denied.component').then(
            (m) => m.AccessDeniedComponent,
          ),
      },
      {
        path: 'profiles',
        canActivate: [canActivateAuthRole],
        loadComponent: () =>
          import('./features/profiles/pages/profiles-dashboard/profiles-dashboard.component').then(
            (m) => m.ProfilesDashboardComponent,
          ),
      },
      {
        path: 'profile-builder',
        canActivate: [canActivateAuthRole],
        loadComponent: () =>
          import('./features/profiles/pages/profile-builder/profile-builder.component').then(
            (m) => m.ProfileBuilderComponent,
          ),
      },
    ],
  },
  { path: '**', redirectTo: 'login' },
];
